// import moment from "moment";
// import React from "react";
// import formatDateDDMMYYYY from "../../../../Main/formatDate";

// const ThermalInvoice = React.forwardRef((props, ref) => {
//   const { values } = props;

//   return (
//     <div ref={ref} style={styles.invoice}>
//       <div style={styles.header}>
//         <h2 className="text-base">{values?.branch?.name}</h2>
//         <p>{values?.branch?.area}</p>
//         <p>
//           {values?.branch?.city ? values?.branch?.city + ", " : ""}
//           {values?.branch?.state}
//         </p>
//         <p>{values?.branch?.country}</p>
//         <p>PHONE : {values?.branch?.phone}</p>
//         <p>EMAIL : {values?.branch?.email}</p>
//         <p>VATIN : {values?.branch?.tax}</p>
//       </div>
//       <div style={styles.details}>
//         <p>Invoice : {`#INV-${values?.number}`}</p>
//         <p>
//           Customer :
//           {values?.customer?.name ? values?.customer?.name : "Walk-in-customer"}
//         </p>
//         <p>Phone :{values?.customer?.phone ? values?.customer?.phone : ""}</p>
//         <p>Date:{formatDateDDMMYYYY(values?.date)}</p>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div style={styles.items}>
//         <table style={styles.table}>
//           <thead>
//             <tr className="border-b border-dashed border-black">
//               <th className="p-1" style={styles.th}>
//                 Item
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Unit
//               </th>
//               <th className="p-1" style={styles.th}>
//                 QTY
//               </th>
//               <th className="p-1" style={styles.th}>
//                 PRC
//               </th>
//               <th className="px-1" style={styles.th}>
//                 TAX
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Total
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {values?.details?.map((item, index) => (
//               <React.Fragment>
//                 <tr key={index}>
//                   <td className="p-1" style={styles.td} colSpan={5}>
//                     <div>{item?.name}&nbsp;</div>
//                     <div>#BATCH-{item?.description?.number}</div>
//                     <div>
//                       {item?.description?.expiry_date
//                         ? "Expiry : " +
//                           formatDateDDMMYYYY(item?.description?.expiry_date)
//                         : ""}
//                     </div>
//                   </td>
//                 </tr>
//                 <tr key={index}>
//                   <td colSpan={1}></td>
//                   <td className="p-1" style={styles.td}>
//                     {item?.unit_name}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.quantity?.toFixed(3)}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.sale_price?.toFixed?.(3)}</div>
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.tax}%</div>
//                     {/* <div>{item?.tax_amount?.toFixed?.(3)}</div> */}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.total?.toFixed?.(3)}
//                   </td>
//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div
//         style={styles?.total}
//         className="pr-2 border-t border-dashed border-black pt-2"
//       >
//         <p>Subtotal: {values?.subtotal?.toFixed(3)}</p>
//         <p>Taxamount: {values?.taxamount?.toFixed(3)}</p>
//         <p>
//           Discount:
//           {values?.discount ? "-" + values?.discount?.toFixed(3) : "0.000"}
//         </p>
//         <p>
//           Delivery:
//           {values?.delivery ? "+" + values?.delivery?.toFixed(3) : "0.000"}
//         </p>
//         <h3 className="text-medium">
//           Total: OMR&nbsp;{values?.total?.toFixed(3)}
//         </h3>
//       </div>
//       <div className="mt-2 border-t border-dashed border-black" />
//       <div className="mt-2 border-t border-dashed border-black" />
//     </div>
//   );
// });

// const styles = {
//   invoice: {
//     width: "80mm",
//     fontSize: "12px",
//     padding: "10px",
//   },
//   header: {
//     textAlign: "center",
//     marginBottom: "10px",
//   },
//   details: {
//     marginBottom: "10px",
//   },
//   items: {
//     marginBottom: "10px",
//   },
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//   },
//   th: {
//     textAlign: "left",
//   },
//   td: {
//     padding: "5px 0",
//   },
//   total: {
//     textAlign: "right",
//   },
// };

// export default ThermalInvoice;


/**
 * new version 2.0 - better Arabic support, cleaner layout, more robust formatting
 * Date - 1-3-2026
 */

import React from "react";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";

const ThermalInvoice = React.forwardRef((props, ref) => {
  const { values } = props;

  const formatLabel = (english, arabic) => (
    <span>
      {english}
      <br />
      <span style={{ fontSize: "10.5px", fontWeight: 500, lineHeight: 1.25 }}>
        {arabic}
      </span>
    </span>
  );

  const infoRow = (englishLabel, arabicLabel, value) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
      <span style={{ direction: "ltr" }}>
        {englishLabel}: {value}
      </span>
      <span style={{
        fontSize: "9px", fontWeight: 500, direction: "rtl", unicodeBidi: "plaintext"
      }}>{arabicLabel}</span>
    </div>
  );

  return (
    <div
      ref={ref}
      // dir="rtl"
      style={{
        ...styles.invoice,
        // direction: "rtl",
        // textAlign: "right",
        fontFamily:
          // Order matters — better chance printer/browser finds a good Arabic font
          "'Amiri', 'Noto Naskh Arabic', 'Traditional Arabic', 'Arial', 'Tahoma', sans-serif",
        WebkitPrintColorAdjust: "exact",       // Helps some browsers
        printColorAdjust: "exact",
      }}
    >

      <div style={{ textAlign: "center", marginBottom: "6px" }}>
        <h2 style={{ margin: "0 0 2px 0", fontSize: "13px", fontWeight: 700 }}>
          {values?.branch?.name}
        </h2>
        <div style={{ textAlign: "center", margin: "1px 0", fontSize: "10px", lineHeight: 1.3 }}>
          VATIN: {values?.branch?.tax || "—"}
        </div>
        <p style={{ margin: "1px 0", fontSize: "10px" }}>
          {[values?.branch?.area, values?.branch?.city, values?.branch?.state, values?.branch?.country]
            .filter(Boolean)
            .join("، ")}
        </p>
        <div style={{ margin: "3px 0 1px 0", fontSize: "10px" }}>
          {infoRow("Phone", "الهاتف", values?.branch?.phone || "—")}
          {values?.branch?.email && infoRow("Email", "البريد الإلكتروني", values.branch.email)}
        </div>
        <p style={{ margin: "4px 0 0 0", fontSize: "10.5px", fontWeight: 700 }}>
          (Tax Invoice / فاتورة ضريبية)
        </p>
      </div>

      <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />
      <div style={{ marginBottom: "6px", fontSize: "7.5px", lineHeight: 1.2 }}>
        <div style={{ margin: "1px 0" }}>{infoRow("Invoice No", "رقم الفاتورة", `#INV-${values?.number}`)}</div>
        <div style={{ margin: "1px 0" }}>{infoRow("Date", "التاريخ", formatDateDDMMYYYY(values?.date))}</div>
        <div style={{ margin: "1px 0" }}>{infoRow("Customer", "العميل", values?.customer?.name || "Walk-in Customer / زبون عابر")}</div>
        <div style={{ margin: "1px 0" }}>{infoRow("Phone", "الهاتف", values?.customer?.phone || "—")}</div>
        <div style={{ margin: "1px 0" }}>{infoRow("Payment Mode", "طريقة الدفع", values?.payments?.name || "—")}</div>
      </div>

      <div className="my-1 border-t border-dashed border-black" />

      <div style={styles.items}>
        <table style={{ ...styles.table, tableLayout: "fixed" }}>
          <thead>
            <tr className="border-b border-dashed border-black" style={{ fontSize: "8px" }}>
              <th style={{ textAlign: "left", width: "34%" }}>{formatLabel("Item", "الصنف")}</th>
              <th style={{ textAlign: "right", width: "14%" }}>{formatLabel("QTY", "الكمية")}</th>
              <th style={{ textAlign: "right", width: "18%" }}>{formatLabel("Price", "السعر")}</th>
              <th style={{ textAlign: "right", width: "14%" }}>{formatLabel("Tax", "الضريبة")}</th>
              <th style={{ textAlign: "right", width: "20%" }}>{formatLabel("Total", "الإجمالي")}</th>
            </tr>
          </thead>
          <tbody>
            {values?.details?.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      ...styles.td,
                      padding: "4px 2px 0px",
                    }}
                  >
                    <div style={{ fontWeight: 400, fontSize: "8.5px", lineHeight: 1.2 }}>
                      {item?.name}
                    </div>

                    {item?.description?.number && (
                      <div style={{ fontSize: "7px", lineHeight: 1.2 }}>
                        #BATCH-{item.description.number}
                      </div>
                    )}

                    {item?.description?.expiry_date && (
                      <div style={{ fontSize: "7px", lineHeight: 1.2 }}>
                        {formatLabel("Expiry", "تاريخ الانتهاء")}:{" "}
                        {formatDateDDMMYYYY(item.description.expiry_date)}
                      </div>
                    )}
                  </td>
                </tr>

                <tr>
                  <td style={{ ...styles.td, width: "6%" }}></td>
                  <td style={{ ...styles.td, textAlign: "right", fontSize: "8px" }}>
                    {Number(item?.quantity || 0).toFixed(3)}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right", fontSize: "8px" }}>
                    {Number(item?.sale_price || 0).toFixed(3)}
                  </td>
                  <td style={{ ...styles.td, textAlign: "right", fontSize: "8px" }}>
                    {Number(item?.tax || 0)}%
                  </td>
                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontWeight: 400,
                      fontSize: "7.5px",
                    }}
                  >
                    {Number(item?.total || 0).toFixed(3)}
                  </td>
                </tr>

                {index < (values?.details?.length || 0) - 1 && (
                  <tr>
                    <td colSpan={5} style={{ height: "6px" }}></td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="my-3 border-t border-dashed border-black" />

      <div style={{ ...styles.total, textAlign: "right", fontSize: "11px", fontWeight: 600, lineHeight: 1.5 }}>
        {infoRow("Subtotal", "المجموع الفرعي", Number(values?.subtotal || 0).toFixed(3))}
        {infoRow("Tax Amount", "مبلغ الضريبة", Number(values?.taxamount || 0).toFixed(3))}
        {values?.discount > 0 && infoRow("Discount", "الخصم", `-${Number(values.discount).toFixed(3)}`)}
        {values?.delivery > 0 && infoRow("Delivery", "التوصيل", `+${Number(values.delivery).toFixed(3)}`)}

        <hr className="my-2 border-black" />

        <div className="flex justify-between text-[12px] font-bold">
          <span>{formatLabel("Grand Total", "الإجمالي")}</span>
          <span><UserCurrency /> / ر.ع {Number(values?.total || 0).toFixed(3)}</span>
        </div>
      </div>

      <div
        style={{
          marginTop: "10px",
          textAlign: "center",
          fontSize: "10px",
          lineHeight: 1.5,
        }}
      >
        Thank you for shopping with us
        <br />
        شكراً لتسوقكم معنا
        <br />
        Wishing you continued health & wellness – نتمنى لكم دوام الصحة والعافية
      </div>
    </div>
  );
});

const styles = {
  invoice: {
    width: "80mm",
    maxWidth: "80mm",
    fontSize: "10.5px",
    lineHeight: 1.35,
    padding: "8px 7px",
    color: "#000",
    backgroundColor: "#fff",
  },
  header: {
    marginBottom: "6px",
  },
  details: {
    marginBottom: "6px",
    lineHeight: 1.35,
  },
  items: {
    marginBottom: "6px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "3px 2px",
    fontWeight: 700,
    fontSize: "10px",
  },
  td: {
    padding: "2px 2px",
    verticalAlign: "top",
  },
  total: {
    fontSize: "11px",
  },
};

export default ThermalInvoice;